import { zodResolver } from '@hookform/resolvers/zod';
import { UserPlus } from 'lucide-react';
import { useForm } from 'react-hook-form';
import { FormattedMessage, useIntl } from 'react-intl';
import { z } from 'zod';

import { Button } from '@/components/ui/button';
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormMessage,
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import { cn } from '@/lib/utils';

const validationSchema = z.object({
  email: z.string().email({
    message: 'i18n.configuration.projectManagement.form.email.error',
  }),
});

type FormValues = z.infer<typeof validationSchema>;

const defaultValues: FormValues = {
  email: '',
};

interface Props {
  setEmail: (email: string) => void;
  isAdmin?: boolean;
}

export const InviteUserForm = ({ setEmail, isAdmin }: Props): JSX.Element => {
  const { formatMessage } = useIntl();

  const form = useForm<FormValues>({
    resolver: zodResolver(validationSchema),
    defaultValues,
  });

  return (
    <div className="mt-1">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(values => setEmail(values.email))}>
          <div className="flex flex-col md:flex-row gap-2">
            <div>
              <Button
                variant="main"
                className="text-white"
                type="submit"
                disabled={isAdmin !== true}
              >
                <UserPlus size={24} className={cn('inline mr-2')} />
                <FormattedMessage id="configuration.projectManagement.form.submit.label" />
              </Button>
            </div>
            <FormField
              control={form.control}
              name="email"
              render={({ field }) => (
                <FormItem className="w-full">
                  <FormControl>
                    <Input
                      {...field}
                      placeholder={formatMessage({
                        id: 'configuration.projectManagement.form.email.placeholder',
                      })}
                      className="w-64"
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </div>
        </form>
      </Form>
    </div>
  );
};
